// src/utils/chatUtils.ts

import { Msg, HistoryChunk } from '../types/chatTypes';

/**
 * Maps chat history messages (Msg[]) to history chunks (HistoryChunk[]) suitable for the API.
 * Filters out error messages and ensures content is not empty.
 * @param history - The array of message objects.
 * @returns An array of history chunk objects.
 */
export function mapHistoryToChunks(history: Msg[]): HistoryChunk[] {
    return history
        .map(msg => {
            // Solo mapeamos mensajes de usuario y bot para enviar al backend como historial conversacional
            if (msg.from === 'error') return null;
            const role = msg.from === 'user' ? 'user' : 'assistant';
            // Asegurarse de que el texto no sea nulo o indefinido
            const content = msg.text || '';
            if (!content.trim()) return null; // Opcional: filtrar mensajes con contenido solo en blanco

            return { role, content };
        })
        .filter((chunk): chunk is HistoryChunk => chunk !== null) as HistoryChunk[]; // Aseguramos el tipo después del filtro
}